module.exports = __webpack_public_path__ + "static/the-queen-of-the-tearling-6b69f2fec85cf1c1532b1f62dd6c84b0.jpg";